/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".about-txt-outer[_ngcontent-%COMP%]{background-color:#eee}.hosting_features[_ngcontent-%COMP%]{background-color:#fff}.page_banner[_ngcontent-%COMP%]{background:url(/assets/images/datamining.jpg) center center no-repeat #333;position:relative}\n/*# sourceMappingURL=mineracao-de-dados.component.css.map*/"];
export { styles as styles };
